const APIFarmerRequest = {};

// GET Requests

APIFarmerRequest["getAllFarmersBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/farmers/registration-form/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllRegistrantClassifications"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/registrant-classification', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getRegistrantClassificationById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/registrant-classification/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllFarmerCategory"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/farmer-category', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getFarmerCategoryById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/farmer-category/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllCivilStatus"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/civil-status', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getCivilStatusById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/civil-status/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllEducationLevels"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/education-level', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getEducationLevelById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/education-level/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllSex"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/sex', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getSexById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/sex/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllRegions"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/region', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getRegionById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/region/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}


APIFarmerRequest["getAllProvinces"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/province', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllProvincesByRegionId"] = async (accessToken, rid) => {
	try {
		const response = await fetch('/api/lib/province/region/' + rid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getProvinceById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/province/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllCities"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/city', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllCitiesByProvinceId"] = async (accessToken, pid) => {
	try {
		const response = await fetch('/api/lib/city/province/' + pid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getCityById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/city/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllBarangays"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/barangay', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllBarangaysByCityId"] = async (accessToken, cid) => {
	try {
		const response = await fetch('/api/lib/barangay/city/' + cid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getBarangayById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/barangay/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllCircumstances"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/rural-women-circumstance', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getCircumstanceById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/rural-women-circumstance/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllLOInstruments"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/land-ownership-instrument', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getInstrumentById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/land-ownership-instrument/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllTypeOfLots"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/lot-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getLotTypeById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/lot-type/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllRelationshipsToARB"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/relationship-to-arb', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getRelationshipToARBById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/relationship-to-arb/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllARBStatuses"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/arb-status', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getARBStatusById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/arb-status/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllCrops"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/crop', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getCropById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/crop/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllFinancing"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/financing', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getFinancingById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/financing/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllARBOCategories"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/arbo-category', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllExtensionNames"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/extension-name', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getFarmerDetailsById"] = async (accessToken, farmerID) => {
	try {
		const response = await fetch('/api/farmers/registration-form/' + farmerID, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getFarmerDetailsByRegistrationNumber"] = async (accessToken, regNum) => {
	try {
		const response = await fetch('/api/farmers/registration/number/' + regNum, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllUserRoles"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/user-role', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getUserRoleById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/user-role/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllUsers"] = async (accessToken) => {
	try {
		const response = await fetch('/api/users/management', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getUsersByRegionId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/users/management/region/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getUsersByProvinceId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/users/management/province/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getUserById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/users/management/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllLoanProviderBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/loan-provider/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllLoanSources"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-source', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllLoanTypes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllLoanTypes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllLoanStatuses"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-status', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["getAllFarmerFinancialTransactionsByFarmerId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/financial-transaction/farmer/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// POST Request

APIFarmerRequest["submitFarmerRegistration"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/farmers/registration-form', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["addFarmerFinancialTransaction"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/financial-transaction', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["addCrop"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/lib/crop', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// PATCH Request

APIFarmerRequest["editFarmerRegistration"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/farmers/registration-form/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["editFarmerFinancialTransaction"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/financial-transaction', {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIFarmerRequest["editCropById"] = async (accessToken, id, data) => {
	try {
		const response = await fetch(`/api/lib/crop/${id}`, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APIFarmerRequest
